import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule, SharedModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { ModalComponent } from './components/modal/modal.component';
import { AccountFormatPipe } from './pipes/account-format/account-format.pipe';
import { CurrencyFormatPipe } from './pipes/currency-format/currency-format.pipe';
import { FilesizePipe } from './pipes/filesize/filesize.pipe';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    ModalComponent,
    AccountFormatPipe,
    CurrencyFormatPipe,
    FilesizePipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DialogModule,
    GridModule,
    LayoutModule,
    SharedModule,
    SortableModule,
    DropDownsModule,
    AccountFormatPipe,
    CurrencyFormatPipe,
    FilesizePipe,
  ],
  entryComponents: [
    ModalComponent,
  ],
})
export class CustomModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CustomModule,
      providers: [DatePipe]
    };
  }
}
